module.exports = __webpack_public_path__ + "static/img/csv.1ac335d4.png";